module.exports = __webpack_public_path__ + "img/single-neutral-phone-book.828365e8.svg";